// import { scan } from 'react-scan'; // must be imported before React and React DOM
// import { StrictMode } from "react";
import { createRoot } from 'react-dom/client';
import './index.css';
import App from './App.jsx';
// import { initSentry } from './shared/config/sentry';

// if (import.meta.env.DEV === false) {
// 	initSentry();
// }
// scan({
// 	enabled: true,
// });
createRoot(document.getElementById('root')).render(<App />);
